// extracted by mini-css-extract-plugin
export default {"cls1":"SearchUpsell-cls1_Mhi","cls2":"SearchUpsell-cls2_Q7u SearchUpsell-cls1_Mhi"};